module.exports = __webpack_public_path__ + "static/media/coffee-breaks.7b010fa0.svg";